module.exports = __webpack_public_path__ + "img/target-05.68821a33.svg";